
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerEditor("Matrix.Rebalancer.ModellingViewColumnGrid", [Serenity.IReadOnly])
    @Serenity.Decorators.element("<div/>")
    export class ModellingViewColumnGrid extends SiteEntityGrid<ModellingViewColumnRow, any>
        implements Serenity.IReadOnly {

        protected getColumnsKey() { return 'Rebalancer.ModellingViewColumn'; }
        protected getDialogType() { return ModellingViewColumnDialog; }
        protected getIdProperty() { return ModellingViewColumnRow.idProperty; }
        protected getLocalTextPrefix() { return ModellingViewColumnRow.localTextPrefix; }
        protected getService() { return ModellingViewColumnService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getInitialTitle() {
            return null;
        }

        private _columnSetCode: string;

        public set columnSetCode(value: string) {
            if (this._columnSetCode !== value) {
                this._columnSetCode = value;
                this.setEquality(ModellingViewColumnRow.Fields.ColumnSetCode, value);
                this.refresh();
            }
        }

        protected addButtonClick() {
            this.editItem(<ModellingViewColumnRow>{
                ColumnSetCode: this._columnSetCode
            });
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this._columnSetCode;
        }

        protected updateInterface() {
            this.toolbar.findButton('add-button').toggle(!this._readOnly && !!this._columnSetCode);
        }

        private _readOnly: boolean;

        get_readOnly(): boolean {
            return !!this._readOnly;
        }

        set_readOnly(value: boolean): void {
            if (!!this._readOnly !== !!value) {
                this._readOnly = !!value;
                this.updateInterface();
            }
        }
    }
}